import { render, staticRenderFns } from "./TableOptionsResetBtn.vue?vue&type=template&id=736cb60e&scoped=true&"
import script from "./TableOptionsResetBtn.vue?vue&type=script&lang=js&"
export * from "./TableOptionsResetBtn.vue?vue&type=script&lang=js&"
import style0 from "./TableOptionsResetBtn.vue?vue&type=style&index=0&id=736cb60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736cb60e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
